import { styled } from 'styled-components';

import {
  colors,
  cssBreakpoints,
  fontSizesByType,
  gutterWidth,
  maxWidth,
} from '#/theme/theme';

export const ArticleHeroBackgroundHolder = styled.div`
  position: absolute;
  transform: translateZ(0);
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const ArticleHeroBackgroundImageHolder = styled.div`
  width: 100%;
  height: 100%;
`;

export const ArticleSearchHeroTitle = styled.div`
  font-size: ${fontSizesByType.h3[0]}px;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    font-size: ${fontSizesByType.h3[2]}px;
  }
`;

export const ArticleSearchHeroContainer = styled.div`
  width: 100%;
  max-width: 400px;
  margin: 0 auto;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    max-width: 622px;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    max-width: ${maxWidth[2]}px;
  }
`;

export const ArticleSearchHeroWrapper = styled.div`
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 0 6px rgb(0 0 0 / 0.3);
  background: ${colors.white};
  color: ${colors.mediumContentGrey};

  @media all and (min-width: ${cssBreakpoints.lgUp}) {
    max-width: ${maxWidth[2]}px;
  }
`;

export const ArticleSearchHero_Box_1 = styled.div`
  min-height: 244px;
  padding-inline: ${gutterWidth / 2}px;
  padding-block: 40px;
  position: relative;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  color: white;

  @media all and (min-width: ${cssBreakpoints.smUp}) {
    min-height: 323px;
    padding-block: 72px;
  }

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    min-height: 394px;
    padding-inline: ${gutterWidth}px;
    padding-block: 108px;
  }
`;
